__webpack_require__.p = "/assets/turbo/e6e55c94/baurde/_next/";